module.exports = __webpack_public_path__ + "static/media/open-right-section.2f9c0737.svg";